var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCosmWasmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_2832_1883)",
    fillRule: "evenodd",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25zM13.14 12.497c.001 4.133 2.649 7.481 5.9 9.586 3.098 2.006 6.773-.072 9.917-2.005 3.975-2.442 9.131-2.69 13.447-.198a13.027 13.027 0 014.05 3.65c.306.422 1.03.221.99-.3C46.875 16.1 42.93 9.36 36.265 5.512c-2.283-1.318-2.506-1.044-2.979-.464-.714.876-1.998 2.452-11.823.293-3.037-.667-6.457.067-7.544 2.98-.49 1.314-.779 2.748-.78 4.177zm6.972 29.038c3.58-2.067 5.155-6.034 5.353-9.902.188-3.686-3.45-5.83-6.695-7.586-4.103-2.221-6.896-6.563-6.896-11.547 0-1.898.407-3.702 1.136-5.332.213-.477-.323-1.003-.753-.707C6.365 10.517 2.5 17.306 2.5 25.001c0 2.636.348 2.692 1.087 2.811 1.116.18 3.123.505 6.166 10.093.94 2.964 3.286 5.559 6.353 5.043 1.382-.233 2.768-.699 4.006-1.413zM30.52 21.297c3.448-1.763 7.671-2.382 11.251-.316 1.238.715 2.335 1.683 3.227 2.763 1.98 2.398.906 5.727-1.19 8.024-6.783 7.428-6.06 9.329-5.658 10.386.266.7.391 1.03-1.892 2.347-6.664 3.848-14.475 3.895-20.934.82-.472-.224-.284-.952.236-1.006a13.026 13.026 0 005.185-1.682c4.316-2.492 6.68-7.082 6.552-11.745-.101-3.69-.064-7.911 3.223-9.591z",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2832_1883",
    x1: 9.3,
    x2: 41.3,
    y1: 2.1,
    y2: 47.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCECB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FF8B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521,
    stopColor: "#FC8ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#7954FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70BCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCosmWasmLogo);
export default __webpack_public_path__ + "static/media/cosm-wasm-logo.2d0864f59a0d760eb74cfc66a47afe38.svg";
export { ForwardRef as ReactComponent };